// Deterministic shuffle using a string seed

function xmur3(str: string): () => number {
	let h = 1779033703 ^ str.length
	for (let i = 0; i < str.length; i++) {
		h = Math.imul(h ^ str.charCodeAt(i), 3432918353)
		h = (h << 13) | (h >>> 19)
	}
	return () => {
		h = Math.imul(h ^ (h >>> 16), 2246822507)
		h = Math.imul(h ^ (h >>> 13), 3266489909)
		const shifted = h >>> 16
		h = h ^ shifted
		return h >>> 0
	}
}

function mulberry32(seed: number): () => number {
	let state = seed
	return () => {
		state = state + 0x6d2b79f5
		let t = state
		t = Math.imul(t ^ (t >>> 15), t | 1)
		t = t ^ (t + Math.imul(t ^ (t >>> 7), t | 61))
		return ((t ^ (t >>> 14)) >>> 0) / 4294967296
	}
}

export function shuffleWithSeed<T>(items: T[], seed: string): T[] {
	const out = items.slice()
	const seedFn = xmur3(seed)
	const rng = mulberry32(seedFn())
	for (let i = out.length - 1; i > 0; i--) {
		const j = Math.floor(rng() * (i + 1))
		const vi = out[i]
		const vj = out[j]
		if (vi === undefined || vj === undefined) continue
		out[i] = vj
		out[j] = vi
	}
	return out
}
